<template>
    <div class="search-filter" ref="searchFilter" v-clickOutside="toggleSearchFilter">
        <div class="search-filter__content">
            <form class="search-filter__form" @submit.prevent="search()">
                <div class="search-filter__title">{{ $t(`searchCustomerFields.${"searchTitle"}`) }}</div>
                <div class="search-filter__row">
                    <div class="search-filter__column">
                        <MultiSelectDropdown :items="userTeams" :placeholder="$t('settingsPage.selectTeamPlaceholder')"
                            label="name" :reduce="(team) => team.id" :selected="userTeamInput" class="team-select"
                            @input="getFiltersData($event)" />
                    </div>

                    <div class="search-filter__column" v-if="searchType == 'user'">
                        <VSelect :options="userStatus" :reduce="(status) => status.value" placeholder="Status"
                            label="name" v-model="selectedStatus" class="select select--default select-column" />
                    </div>

                    <div class="search-filter__column" v-if="searchType !== 'user'"></div>
                    <div class="search-filter__column" v-if="searchType !== 'user'"></div>
                </div>

                <Loading v-if="loadingResurces" />

                <div v-else>
                    <div class="search-filter__row" v-if="searchType !== 'user'">
                        <div class="search-filter__column" v-if="searchType !== 'policy' && searchType !== 'lead'">
                            <input disabled v-if="userTeamLength > 1 && userTeamInput.length == 0"
                                placeholder="Company Type" style="width: 100%;"
                                class="multi__placeholder input input--default input--shadow" />

                            <MultiSelectDropdown v-else :items="resource.companyTypes" placeholder="Company Type"
                                label="type" @input="companyTypes = $event" :reduce="(type) => type.id"
                                :selected="companyTypes" />
                        </div>

                        <div class="search-filter__column" v-if="searchType == 'lead'">
                            <input disabled v-if="userTeamLength > 1 && userTeamInput.length == 0"
                                :placeholder="$t('searchLeads.leadStatus')" style="width: 100%;"
                                class="multi__placeholder input input--default input--shadow" />

                            <MultiSelectDropdown v-else :items="resource.customer_sub_statuses || []"
                                :placeholder="$t('searchLeads.leadStatus')" label="name" @input="leadStatuses = $event"
                                :reduce="(status) => status.id" :selected="leadStatuses" />
                        </div>

                        <div class="search-filter__column"
                            v-if="searchType !== 'potentialCustomer' && searchType !== 'lead'">
                            <input disabled v-if="userTeamLength > 1 && userTeamInput.length == 0"
                                :placeholder="$t('searchCustomerFields.companyTitle')" style="width: 100%;"
                                class="multi__placeholder input input--default input--shadow" />

                            <MultiSelectDropdown v-else :items="resource.companies"
                                :placeholder="$t('searchCustomerFields.companyTitle')" label="name"
                                @input="companies = $event" :reduce="(company) => company.id" :selected="companies" />
                        </div>

                        <div class="search-filter__column" v-if="searchType == 'lead'">
                            <input disabled
                                v-if="(userTeamLength > 1 && userTeamInput.length == 0) || (!resource.branchCategories || resource.branchCategories.length === 0)"
                                :placeholder="$t('searchLeads.leadCategory')" style="width: 100%;"
                                class="multi__placeholder input input--default input--shadow" />

                            <MultiSelectDropdown v-else :items="resource.branchCategories || []"
                                :placeholder="$t('searchLeads.leadCategory')" :label="`long_${language}`"
                                @input="leadCategories = $event" :reduce="(category) => category.id"
                                :selected="leadCategories" />
                        </div>

                        <div class="search-filter__column" v-if="searchType == 'lead'">
                            <input disabled
                                v-if="(userTeamLength > 1 && userTeamInput.length == 0) || (!resource.referrals || resource.referrals.length === 0)"
                                :placeholder="$t('searchLeads.leadReferral')" style="width: 100%;"
                                class="multi__placeholder input input--default input--shadow" />

                            <MultiSelectDropdown v-else :items="resource.referrals || []"
                                :placeholder="$t('searchLeads.leadReferral')" label="name"
                                @input="leadReferals = $event" :reduce="(referral) => referral.id"
                                :selected="leadReferals" />
                        </div>
                    </div>
                    <div class="search-filter__row" v-if="searchType !== 'user'"
                        style="margin-bottom: 10px !important;">
                        <div v-if="searchType !== 'potentialCustomer' && searchType !== 'lead'"
                            class="search-filter__column">
                        </div>
                        <div class="search-filter__column">
                        </div>
                        <div class="search-filter__column search-filter__column--inputs" v-if="searchType == 'lead'">
                            <label class="date-label">{{ $t('searchCustomerFields.zip') }}</label>
                        </div>
                        <div class="search-filter__column search-filter__column--inputs" v-if="searchType == 'lead'">
                            <label class="date-label">{{ $t('searchLeads.deadline') }}</label>
                        </div>
                    </div>
                    <div class="search-filter__row" v-if="searchType !== 'user'">
                        <div v-if="searchType !== 'potentialCustomer' && searchType !== 'lead'"
                            class="search-filter__column">
                            <input disabled v-if="userTeamLength > 1 && userTeamInput.length == 0" placeholder="Status"
                                style="width: 100%;" class="multi__placeholder input input--default input--shadow" />

                            <MultiSelectDropdown v-else :items="resource.policyStatuses" placeholder="Status"
                                label="name" @input="policyStatuses = $event" :reduce="(status) => status.id"
                                :selected="policyStatuses" />
                        </div>

                        <div class="search-filter__column">
                            <input disabled v-if="userTeamLength > 1 && userTeamInput.length == 0"
                                :placeholder="$t('searchCustomerFields.agentTitle')" style="width: 100%;"
                                class="multi__placeholder input input--default input--shadow" />

                            <MultiSelectDropdown v-else :items="resource.agents || []"
                                :placeholder="$t('searchCustomerFields.agentTitle')" @input="agents = $event"
                                :customLabel="(agent) => `${agent.first_name} ${agent.last_name}`"
                                :reduce="(agent) => agent.id" :selected="agents" />
                        </div>

                        <div class="search-filter__column search-filter__column--inputs" v-if="searchType == 'lead'">
                            <div class="form__field">
                                <div class="report__choose-details-datepickers">
                                    <input v-if="userTeamLength > 1 && userTeamInput.length == 0" type="text"
                                        class="input input--default disabled-input" placeholder="Von" disabled />

                                    <input v-else type="text" class="input input--default" placeholder="Von"
                                        v-model="zipFrom" />

                                    <div class="input input--default report__choose-details-seperator">-</div>

                                    <input v-if="userTeamLength > 1 && userTeamInput.length == 0" type="text"
                                        class="input input--default disabled-input" placeholder="Bis" disabled />

                                    <input v-else type="text" class="input input--default" placeholder="Bis"
                                        v-model="zipTo" />
                                </div>
                            </div>
                        </div>

                        <div class="search-filter__column search-filter__column--inputs" v-if="searchType == 'lead'">
                            <div class="form__field">
                                <div class="report__choose-details-datepickers">
                                    <Datepicker v-if="userTeamLength > 1 && userTeamInput.length == 0"
                                        class="input input--default disabled-input" placeholder="Von" disabled />

                                    <Datepicker v-else class="input input--default" :config="statics.datePickerConfig"
                                        placeholder="Von" id="deadlineFromInput" ref="deadlineFromInput"
                                        v-model="deadlineFrom" />

                                    <div class="input input--default report__choose-details-seperator">-</div>

                                    <Datepicker v-if="userTeamLength > 1 && userTeamInput.length == 0"
                                        class="input input--default disabled-input" placeholder="Bis" disabled />

                                    <Datepicker v-else class="input input--default" :config="statics.datePickerConfig"
                                        placeholder="Bis" id="deadlineToInput" ref="deadlineToInput"
                                        v-model="deadlineTo" />
                                </div>
                            </div>
                        </div>

                        <div class="search-filter__column" v-if="searchType == 'potentialCustomer'">
                            <input disabled v-if="userTeamLength > 1 && userTeamInput.length == 0"
                                placeholder="Priorities" style="width: 100%;"
                                class="multi__placeholder input input--default input--shadow" />

                            <MultiSelectDropdown v-else :items="resource.priorities" placeholder="Priorities"
                                @input="priorities = $event" label="type" :reduce="(priority) => priority.id"
                                :selected="priorities" />
                        </div>

                        <div class="search-filter__column " v-if="searchType == 'customer'">
                            <input disabled v-if="userTeamLength > 1 && userTeamInput.length == 0"
                                placeholder="Kündigungen" style="width: 100%;"
                                class="multi__placeholder input input--default input--shadow" />

                            <VSelect v-else :options="terminationsArr" :reduce="(termination) => termination.value"
                                placeholder="Kündigungen" label="name" v-model="selectedTermination"
                                class="select select--default select-column" />
                        </div>


                    </div>

                    <div v-if="searchType !== 'user' && searchType !== 'lead'" class="divider">
                        <div class="line-divider"></div>
                        <div class="text-divider" @click="moreFilters = !moreFilters">
                            <p v-if="moreFilters">{{ $t(`searchCustomerFields.${"lessFilters"}`) }}</p>
                            <p v-else>{{ $t(`searchCustomerFields.${"moreFilters"}`) }}</p>
                            <img src="../assets/icons/default/Bold 2px-chevron_down.svg" :style="textDividerStyle">
                        </div>
                    </div>

                    <transition name="slide-fade-in">
                        <div v-if="moreFilters && searchType !== 'user' && searchType !== 'lead'">
                            <div class="search-filter__row" style="margin-bottom: 10px !important;">
                                <div v-if="searchType == 'customer'"
                                    class="search-filter__column search-filter__column--inputs"></div>
                                <div class="search-filter__column search-filter__column--inputs">
                                    <label class="date-label">{{ $t(`searchCustomerFields.${"policyStartDate"}`)
                                        }}</label>
                                </div>
                                <div v-if="searchType !== 'potentialCustomer'"
                                    class="search-filter__column search-filter__column--inputs">
                                    <label class="date-label">{{ $t(`searchCustomerFields.${"policySubmitDate"}`)
                                        }}</label>
                                </div>
                            </div>

                            <div class="search-filter__row">
                                <div class="search-filter__column search-filter__column--inputs"
                                    v-if="searchType == 'customer'">
                                    <div class="search-filter__column"
                                        v-if="$checkRolePermission('policy_service_payment_access')">
                                        <input disabled v-if="userTeamLength > 1 && userTeamInput.length == 0"
                                            :placeholder="$t('searchCustomerFields.paymentTitle')" style="width: 100%;"
                                            class="multi__placeholder input input--default input--shadow" />

                                        <v-select v-else :options="paymentStatusArr" :reduce="(status) => status.value"
                                            :placeholder="$t('searchCustomerFields.paymentTitle')" label="name"
                                            v-model="paymentStatus"
                                            class="select select--default select-column payment-type">
                                            <template #option="option">
                                                <div class="custom-option">
                                                    <div class="icon custom-option-icon" :class="option.icon"></div>
                                                    <div class="option-name">{{ option.name }}</div>
                                                </div>
                                            </template>
                                        </v-select>
                                    </div>
                                </div>

                                <div class="search-filter__column search-filter__column--inputs">
                                    <div class="form__field">
                                        <div class="report__choose-details-datepickers">
                                            <Datepicker v-if="userTeamLength > 1 && userTeamInput.length == 0"
                                                class="input input--default disabled-input" placeholder="Von"
                                                disabled />

                                            <Datepicker v-else class="input input--default"
                                                :config="statics.datePickerConfig" placeholder="Von"
                                                id="startDateFromInput" ref="startDateFromInput"
                                                v-model="startDateFrom" />

                                            <div class="input input--default report__choose-details-seperator">-</div>

                                            <Datepicker v-if="userTeamLength > 1 && userTeamInput.length == 0"
                                                class="input input--default disabled-input" placeholder="Bis"
                                                disabled />

                                            <Datepicker v-else class="input input--default"
                                                :config="statics.datePickerConfig" placeholder="Bis"
                                                id="startDateToInput" ref="startDateToInput" v-model="startDateTo" />
                                        </div>
                                    </div>
                                </div>

                                <div class="search-filter__column search-filter__column--inputs"
                                    v-if="searchType !== 'potentialCustomer' && searchType !== 'lead'">
                                    <div class="form__field">
                                        <div class="report__choose-details-datepickers">
                                            <Datepicker v-if="userTeamLength > 1 && userTeamInput.length == 0"
                                                class="input input--default disabled-input" placeholder="Von"
                                                disabled />

                                            <Datepicker v-else class="input input--default"
                                                :config="statics.datePickerConfig" placeholder="Von"
                                                v-model="submitDateFrom" id="submitDateInput" ref="submitDateInput" />

                                            <div class="input input--default report__choose-details-seperator">-</div>

                                            <Datepicker v-if="userTeamLength > 1 && userTeamInput.length == 0"
                                                class="input input--default disabled-input" placeholder="Bis"
                                                disabled />

                                            <Datepicker v-else class="input input--default"
                                                :config="statics.datePickerConfig" placeholder="Bis"
                                                v-model="submitDateTo" id="submitDateToInput" ref="submitDateToInput" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>

                    <transition name="slide-fade-in">
                        <div v-if="moreFilters && searchType !== 'user' && searchType !== 'lead'"
                            class="search-filter__row" style="margin-bottom: 10px !important;">
                            <div class="search-filter__column search-filter__column--inputs"
                                v-if="searchType !== 'policy'">
                                <label class="date-label" v-if="searchType == 'customer'">{{
                                    $t('searchCustomerFields.birthday') }}</label>
                            </div>

                            <div class="search-filter__column search-filter__column--inputs"
                                v-if="searchType !== 'policy'">
                                <label class="date-label"
                                    v-if="searchType == 'customer' || searchType == 'potentialCustomer'">{{
                                        $t('searchCustomerFields.zip') }}</label>
                            </div>
                            <div class="search-filter__column search-filter__column--inputs">
                                <label class="date-label">{{ $t(`searchCustomerFields.${"policyEndDate"}`) }}</label>
                            </div>
                        </div>
                    </transition>

                    <div class="search-filter__row"
                        v-if="moreFilters && searchType !== 'user' && searchType !== 'lead'">
                        <transition name="slide-fade-in">
                            <div class="search-filter__column search-filter__column--inputs"
                                v-if="searchType !== 'policy'">

                                <div v-if="searchType == 'customer'" class="search-filter__column">
                                    <div class="filter-birthday">
                                        <Datepicker v-if="userTeamLength > 1 && userTeamInput.length == 0"
                                            class="input input--default disabled-input "
                                            :placeholder="$t('searchCustomerFields.birthday')" disabled />

                                        <Datepicker v-else class="input input--default birthday  "
                                            :config="statics.datePickerConfig"
                                            :placeholder="$t('searchCustomerFields.birthday')" id="birthday"
                                            v-model="birthday" />
                                    </div>
                                </div>

                                <div class="search-filter__column"
                                    v-if="searchType == 'customer' || searchType == 'potentialCustomer'">
                                    <div class="form__field">
                                        <div class="report__choose-details-datepickers">
                                            <input v-if="userTeamLength > 1 && userTeamInput.length == 0" type="text"
                                                class="input input--default disabled-input" placeholder="Von"
                                                disabled />

                                            <input v-else type="text" class="input input--default" placeholder="Von"
                                                v-model="zipFrom" />

                                            <div class="input input--default report__choose-details-seperator">-</div>

                                            <input v-if="userTeamLength > 1 && userTeamInput.length == 0" type="text"
                                                class="input input--default disabled-input" placeholder="Bis"
                                                disabled />

                                            <input v-else type="text" class="input input--default" placeholder="Bis"
                                                v-model="zipTo" />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </transition>

                        <transition name="slide-fade-in">
                            <div class="search-filter__column search-filter__column--inputs">
                                <div class="search-filter__column">
                                    <div class="form__field">
                                        <div class="report__choose-details-datepickers">
                                            <Datepicker v-if="userTeamLength > 1 && userTeamInput.length == 0"
                                                class="input input--default disabled-input" placeholder="Von"
                                                disabled />

                                            <Datepicker v-else class="input input--default"
                                                :config="statics.datePickerConfig" placeholder="Von"
                                                v-model="endDateFrom" id="endDateFromInput" ref="endDateFromInput" />

                                            <div class="input input--default report__choose-details-seperator">-</div>

                                            <Datepicker v-if="userTeamLength > 1 && userTeamInput.length == 0"
                                                class="input input--default disabled-input" placeholder="Bis"
                                                disabled />

                                            <Datepicker v-else class="input input--default"
                                                :config="statics.datePickerConfig" placeholder="Bis" v-model="endDateTo"
                                                id="endDateToInput" ref="endDateToInput" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>

                    <div class="search-filter__row" v-if="moreFilters && searchType == 'customer'">
                        <transition name="slide-fade-in">
                            <div class="search-filter__column">
                                <label class="date-label" style="display: block; margin-bottom: 10px;">{{ $t(`pendenciesTable.${"pendencyNr"}`) }}</label> 
                                <input 
                                    v-if="userTeamLength > 1 && userTeamInput.length == 0" 
                                    type="text"
                                    class="input input--default disabled-input" 
                                    :placeholder="$t(`pendenciesTable.${'pendencyNr'}`)" disabled 
                                />

                                <input 
                                    v-else 
                                    type="text" 
                                    class="input input--default" 
                                    :placeholder="$t(`pendenciesTable.${'pendencyNr'}`)"  
                                    v-model="pendencyNr" 
                                />
                            </div>
                        </transition>
                    </div>

                    <transition name="slide-fade-in">
                        <div class="search-filter__row" v-if="moreFilters && userTeamInput.length > 0">
                            <div class="search-filter__column search-filter__column--inputs"
                                v-if="searchType == 'customer' && $checkRolePermission('customer_export')">
                                <transition name="slide-fade-in">
                                    <div class="search-filter__column">
                                        <a style="width: 30% !important; margin-left: auto !important;"
                                            v-show="!isRequesting" type="button" @click="exportCustomersTable()"
                                            class="search-export__button button button--default">
                                            Export
                                            <img src="../assets/icons/default/export_files_icon.svg"
                                                alt="export-icon" />
                                        </a>
                                    </div>
                                </transition>
                            </div>
                            <div class="search-filter__column search-filter__column--inputs"
                                v-if="searchType == 'policy' && $checkRolePermission('policy_export')">
                                <transition name="slide-fade-in">
                                    <div class="search-filter__column">
                                        <a style="width: 30% !important; margin-left: auto !important;"
                                            v-show="!isRequesting" type="button" @click="exportPoliciesTable()"
                                            class="search-export__button button button--default">
                                            Export
                                            <img src="../assets/icons/default/export_files_icon.svg"
                                                alt="export-icon" />
                                        </a>
                                    </div>
                                </transition>
                            </div>


                            <div class="search-filter__column search-filter__column--inputs"
                                v-if="searchType == 'user' && $checkRolePermission('customer_export')">
                                <transition name="slide-fade-in">
                                    <div class="search-filter__column">
                                        <a style="width: 30% !important; margin-left: auto !important;"
                                            v-show="!isRequesting" type="button" @click="exportUsersTable()"
                                            class="search-export__button button button--default">
                                            Export
                                            <img src="../assets/icons/default/export_files_icon.svg"
                                                alt="export-icon" />
                                        </a>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </transition>

                    <transition name="slide-fade-in">
                        <div class="search-filter__column search-filter__column--inputs"
                            v-if="searchType == 'lead' && $checkRolePermission('customer_export')">
                            <transition name="slide-fade-in">
                                <div class="search-filter__column">
                                    <a style="width: 30% !important; margin-left: auto !important;"
                                        v-show="!isRequesting" type="button" @click="exportLeadsTable()"
                                        class="search-export__button button button--default">
                                        Export
                                        <img src="../assets/icons/default/export_files_icon.svg" alt="export-icon" />
                                    </a>
                                </div>
                            </transition>
                        </div>
                    </transition>

                    <div v-show="isRequesting" ref="loadingButton"
                        class="search-filter__button button button--default button--loading">
                    </div>
                    <button v-show="!isRequesting && userTeamInput.length > 0" type="button" @click="search()"
                        class="search-filter__button button button--default">
                        {{ $t(`searchCustomerFields.${"applyBtn"}`) }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Loading from "@/partials/Loading";
import statics from "@/statics";
import {
    mapGetters
} from "vuex";
import withPopper from "@/helpers/withPopper";
import MultiSelectDropdown from "@/partials/MultiSelectDropdown";
export default {
    name: "SearchFilter",

    components: {
        MultiSelectDropdown,
        Loading
    },

    props: {
        toggleSearchFilter: {
            required: true,
            type: Function,
        },
        filterToggler: {
            required: true,
            type: null,
        },

        searchType: {
            required: true,
            type: String,
        },
    },

    directives: {
        clickOutside: {
            bind(el, binding, vnode) {
                el.mouseDown = false;

                el.handleMouseDown = () => {
                    el.mouseDown = true;
                };

                el.handleMouseUp = (event) => {
                    if (!el.mouseDown) return;

                    el.mouseDown = false;

                    const isClickInsideElement = (
                        event.target === vnode.context.filterToggler ||
                        event.target === vnode.context.$refs.searchFilter || [...el.getElementsByTagName("*")].includes(event.target) ||
                        event.target.closest('.flatpickr-calendar')
                    );

                    if (isClickInsideElement) {
                        vnode.context[binding.expression](true);
                    } else {
                        vnode.context[binding.expression](false);
                    }
                };

                document.addEventListener("mousedown", el.handleMouseDown);
                document.addEventListener("mouseup", el.handleMouseUp);
            },
            unbind(el) {
                document.removeEventListener("mousedown", el.handleMouseDown);
                document.removeEventListener("mouseup", el.handleMouseUp);
            },
        },
    },

    data() {
        return {
            loadingResurces: false,

            userTeamInput: [],

            selectedTeam: null,

            moreFilters: false,

            statics,
            withPopper,
            isRequesting: false,
            birthday: "",
            zipFrom: "",
            zipTo: "",
            agents: [],
            companyTypes: [],
            companies: [],
            branchCategories: [],
            policyStatuses: [],
            priorities: [],
            leadStatuses: [],
            leadCategories: [],
            leadReferals: [],
            deadlineFrom: "",
            deadlineTo: "",
            searchKeywords: "",
            resource: {},
            export: false,

            selectedTermination: '',

            selectedStatus: null,

            startDateFrom: "",
            startDateTo: "",

            endDateFrom: "",
            endDateTo: "",

            pendencyNr: "",

            submitDateFrom: "",
            submitDateTo: "",

            paymentStatus: '',

            terminationsArr: [
                {
                    id: 1,
                    value: 'true',
                    name: 'Ja'
                },
                {
                    id: 2,
                    value: 'false',
                    name: 'Nien'
                }
            ],

            userStatus: [
                {
                    id: 1,
                    value: null,
                    name: 'All'
                },
                {
                    id: 2,
                    value: "1",
                    name: 'Active'
                },
                {
                    id: 3,
                    value: "0",
                    name: 'Inactive'
                }
            ],

            paymentStatusArr: [
                {
                    id: 1,
                    value: 'unpaid',
                    name: 'Unbezahlt',
                    icon: 'icon__payment'
                },
                {
                    id: 2,
                    value: 'pending',
                    name: 'Zahlung hinzugefügt (ausstehend)',
                    icon: 'icon__payment--pending'
                },
                {
                    id: 3,
                    value: 'paid',
                    name: 'Bezahlt',
                    icon: 'icon__payment--paid'
                }
            ]


        };
    },
    async created() {

        if (this.$route.name === "PotentialCustomers") {
            this.resource = this.searchPotentialCustomerForms;
        } else if (this.$route.name === "Policies") {
            this.resource = this.searchPoliciesForms;
        } else if (this.$route.name === "Leads") {
            this.resource = this.searchLeadForms;
        } else {
            this.resource = this.searchCustomerForms;
        }
        const {
            search,
            agents,
            companyTypes,
            companies,
            branchCategories,
            policyStatuses,
            priorities,
            lead_statuses,
            lead_categories,
            lead_referrals,
            deadline_from,
            deadline_to,
            birthday,
            zip_from,
            zip_to,
            startDateFrom,
            startDateTo,
            endDateFrom,
            endDateTo,
            submitDateFrom,
            submitDateTo,
            has_terminations,
            payment_status,
            pendency_number,
            teams
        } = this.$route.query;
        this.searchKeywords = search || "";
        this.agents = agents ? agents.split(",").map((i) => i) : [];
        this.companyTypes = companyTypes ?
            companyTypes.split(",").map((i) => i) :
            [];
        this.companies =
            companies && (this.$route.name === "Customers" || this.$route.name === "Policies") ?
                companies.split(",").map((i) => i) :
                [];
        this.branchCategories = branchCategories ?
            branchCategories.split(",").map((i) => i) :
            [];
        this.policyStatuses =
            policyStatuses && (this.$route.name === "Customers" || this.$route.name === "Policies") ?
                policyStatuses.split(",").map((i) => i) :
                [];
        this.priorities =
            priorities && this.$route.name === "PotentialCustomers" ?
                priorities.split(",").map((i) => i) :
                [];
        this.leadStatuses =
            lead_statuses && this.$route.name === "Leads" ?
                lead_statuses.split(",").map(i => Number(i)) :
                [];
        this.leadCategories =
            lead_categories && this.$route.name === "Leads" ?
                lead_categories.split(",").map(i => Number(i)) :
                [];
        this.leadReferals =
            lead_referrals && this.$route.name === "Leads" ?
                lead_referrals.split(",").map(i => Number(i)) :
                [];
        this.deadlineFrom = deadline_from || "";
        this.deadlineTo = deadline_to || "";
        this.birthday = birthday || "";
        this.zipFrom = zip_from || "";
        this.zipTo = zip_to || "";

        this.startDateFrom = startDateFrom || "";
        this.startDateTo = startDateTo || "";
        this.endDateFrom = endDateFrom || "";
        this.endDateTo = endDateTo || "";
        this.submitDateFrom = submitDateFrom || "";
        this.submitDateTo = submitDateTo || "";
        this.selectedTermination = has_terminations || '';

        this.paymentStatus = payment_status || '';
        this.pendencyNr = ["Customers", "Dashboard", "AccountDetails"].includes(this.$route.name)
            ? (pendency_number || "")
            : "";

        if (Array.isArray(teams)) {
            this.userTeamInput = teams.map(Number);
        } else if (typeof teams === "string" && teams.length) {
            this.userTeamInput = teams.split(",").map(Number);
        } else {
            this.userTeamInput = [];
        }

        if (this.userTeamInput.length) {
            await this.getFiltersData(this.userTeamInput);
        }

    },
    computed: {
        ...mapGetters([
            "searchCustomerForms",
            "searchPotentialCustomerForms",
            "searchLeadForms",
            "language",
            "searchPoliciesForms",

            "loggedUser",
        ]),

        terminationValue() {
            if (this.selectedTermination === 'true') {
                return true;
            } else if (this.selectedTermination === 'false') {
                return false;
            }
            return ''
        },

        textDividerStyle() {
            return {
                transform: this.moreFilters ? 'scaleY(-1)' : 'scaleY(1)',
                transition: 'transform 0.3s ease'
            };
        },

        userTeams() {
            if (!this.loggedUser || !this.loggedUser.teams) return [];
            return this.loggedUser.teams;
        },

        userTeamLength() {
            if (!this.loggedUser || !this.loggedUser.teams) return 0;
            return this.loggedUser.teams.length
        }
    },
    watch: {
        startDateFrom(newDate) {
            if ((newDate > this.startDateTo) || !this.startDateTo) {
                this.startDateTo = newDate;
            }
            this.$nextTick(() => {
                const dateToInput = this.$refs.startDateToInput.fp;
                if (dateToInput) {
                    dateToInput.open();
                }
            });
        },
        startDateTo(newDate) {
            if ((newDate < this.startDateFrom) || !this.startDateFrom) {
                this.startDateFrom = newDate;
            }
        },

        endDateFrom(newDate) {
            if ((newDate > this.endDateTo) || !this.endDateTo) {
                this.endDateTo = newDate;
            }
            this.$nextTick(() => {
                const dateToInput = this.$refs.endDateToInput.fp;
                if (dateToInput) {
                    dateToInput.open();
                }
            });
        },
        endDateTo(newDate) {
            if ((newDate < this.endDateFrom) || !this.endDateFrom) {
                this.endDateFrom = newDate;
            }
        },

        submitDateFrom(newDate) {
            if ((newDate > this.submitDateTo) || !this.submitDateTo) {
                this.submitDateTo = newDate;
            }
            this.$nextTick(() => {
                const dateToInput = this.$refs.submitDateToInput.fp;
                if (dateToInput) {
                    dateToInput.open();
                }
            });
        },
        submitDateTo(newDate) {
            if ((newDate < this.submitDateFrom) || !this.submitDateFrom) {
                this.submitDateFrom = newDate;
            }
        },

        deadlineFrom(newDate) {
            if ((newDate > this.deadlineTo) || !this.deadlineTo) {
                this.deadlineTo = newDate;
            }
            this.$nextTick(() => {
                const dateToInput = this.$refs.deadlineToInput.fp;
                if (dateToInput) {
                    dateToInput.open();
                }
            });
        },
        deadlineTo(newDate) {
            if ((newDate < this.deadlineFrom) || !this.deadlineFrom) {
                this.deadlineFrom = newDate;
            }
        }
    },
    methods: {
        async getFiltersData(teamIds) {
            this.userTeamInput = teamIds;
            this.moreFilters = false;
            this.loadingResurces = true;

            if (Array.isArray(teamIds) && teamIds.length) {
                if (this.searchType === 'customer') {
                    await this.$store.dispatch("getSearchCustomerForms", teamIds);
                    this.resource = null;
                    this.resource = this.searchCustomerForms;
                } else if (this.searchType === 'lead') {
                    await this.$store.dispatch("getSearchLeadForms", teamIds);
                    this.resource = null;
                    this.resource = this.searchLeadForms;
                } else if (this.searchType === 'potentialCustomer') {
                    await this.$store.dispatch("getSearchPotentialCustomerForms", teamIds);
                    this.resource = null;
                    this.resource = this.searchPotentialCustomerForms;
                } else if (this.searchType === 'policy') {
                    await this.$store.dispatch("getSearchPoliciesForms", teamIds);
                    this.resource = null;
                    this.resource = this.searchPoliciesForms;
                } else if (this.searchType === 'user') {
                    this.selectedTeam = teamIds;
                }
            }

            this.loadingResurces = false;
        },

        openStartDateToPicker() {
            this.$nextTick(() => {
                const dateToInput = this.$refs.startDateToInput.fp;
                if (dateToInput) {
                    dateToInput.open();
                }
            });
        },

        async search() {
            this.isRequesting = true;

            const selectedTeams = this.userTeamInput?.length ? this.userTeamInput : this.selectedTeam || [];

            if (this.$route.name === "Customers" || this.$route.name === "Dashboard" || this.$route.name === "AccountDetails") {
                const query = {
                    page: 1,
                    search: this.searchKeywords || undefined,
                    teams: selectedTeams.length ? selectedTeams.join(",") : undefined,
                    agents: this.agents.length ? this.agents.join(",") : undefined,
                    companyTypes: this.companyTypes.length ? this.companyTypes.join(",") : undefined,
                    companies: this.companies.length ? this.companies.join(",") : undefined,
                    branchCategories: this.branchCategories.length ? this.branchCategories.join(",") : undefined,
                    policyStatuses: this.policyStatuses.length ? this.policyStatuses.join(",") : undefined,
                    has_terminations: this.terminationValue || undefined,
                    payment_status: this.paymentStatus || undefined,
                    birthday: this.birthday || undefined,
                    zip_from: this.zipFrom || undefined,
                    zip_to: this.zipTo || undefined,
                    startDateFrom: this.startDateFrom || undefined,
                    startDateTo: this.startDateTo || undefined,
                    endDateFrom: this.endDateFrom || undefined,
                    endDateTo: this.endDateTo || undefined,
                    submitDateFrom: this.submitDateFrom || undefined,
                    submitDateTo: this.submitDateTo || undefined,
                    ...( ["Customers", "Dashboard", "AccountDetails"].includes(this.$route.name)
                        ? { pendency_number: this.pendencyNr || undefined }
                        : {}),
                };

                if (this.$route.name === "Customers") {
                    this.$router.replace({ query }).catch(() => { });
                } else {
                    this.$router.push({ path: "/customers", query }).catch(() => { });
                }

                this.toggleSearchFilter(false);
            }
            else if (this.$route.name === "PotentialCustomers") {
                const query = {
                    page: 1,
                    teams: selectedTeams.join(","),
                    search: this.searchKeywords,
                    agents: this.agents.join(","),
                    companyTypes: this.companyTypes.join(","),
                    branchCategories: this.branchCategories.join(","),
                    priorities: this.priorities.join(","),
                    birthday: this.birthday,
                    startDateFrom: this.startDateFrom,
                    startDateTo: this.startDateTo,
                    endDateFrom: this.endDateFrom,
                    endDateTo: this.endDateTo,
                    zip_from: this.zipFrom,
                    zip_to: this.zipTo,
                }
                await this.$router.replace({ name: "PotentialCustomers", query }).catch(() => { });
                this.toggleSearchFilter(false);
            } else if (this.$route.name === "Policies") {
                const query = {
                    page: 1,
                    search: this.searchKeywords || undefined,
                    teams: selectedTeams.length ? selectedTeams.join(",") : undefined,
                    agents: this.agents.length ? this.agents.join(",") : undefined,
                    companies: this.companies.length ? this.companies.join(",") : undefined,
                    branchCategories: this.branchCategories.length ? this.branchCategories.join(",") : undefined,
                    policyStatuses: this.policyStatuses.length ? this.policyStatuses.join(",") : undefined,
                    startDateFrom: this.startDateFrom || undefined,
                    startDateTo: this.startDateTo || undefined,
                    endDateFrom: this.endDateFrom || undefined,
                    endDateTo: this.endDateTo || undefined,
                    submitDateFrom: this.submitDateFrom || undefined,
                    submitDateTo: this.submitDateTo || undefined,
                };

                await this.$router.replace({ name: "Policies", query }).catch(() => { });
                this.toggleSearchFilter(false);
            } else if (this.$route.name === "Users") {
                const query = {
                    page: 1,
                    search: this.searchKeywords || undefined,
                    teams: selectedTeams && selectedTeams.length ? selectedTeams.join(",") : undefined,
                    active_users: (this.selectedStatus !== null && this.selectedStatus !== undefined)
                        ? this.selectedStatus
                        : undefined
                };

                await this.$router.replace({ name: "Users", query }).catch(() => { });
                this.toggleSearchFilter(false);
            } else if (this.$route.name === "Leads") {
                const query = {
                    page: 1,
                    search: this.searchKeywords || undefined,
                    teams: selectedTeams.length ? selectedTeams.join(",") : undefined,
                    agents: this.agents.length ? this.agents.join(",") : undefined,
                    lead_statuses: this.leadStatuses.length ? this.leadStatuses.join(",") : undefined,
                    lead_categories: this.leadCategories.length ? this.leadCategories.join(",") : undefined,
                    lead_referrals: this.leadReferals.length ? this.leadReferals.join(",") : undefined,
                    deadline_from: this.deadlineFrom || undefined,
                    deadline_to: this.deadlineTo || undefined,
                    zip_from: this.zipFrom || undefined,
                    zip_to: this.zipTo || undefined,
                };

                await this.$router.replace({ name: "Leads", query }).catch(() => { });
                this.toggleSearchFilter(false);
            }
            this.toggleSearchFilter(false);
            this.isRequesting = false;
        },

        async exportCustomersTable() {
            this.isRequesting = true;
            if (this.$route.name === "Customers") {
                const selectedTeams = this.userTeamInput?.length ? this.userTeamInput : this.selectedTeam || [];

                await this.$store.dispatch("searchCustomers", {
                    search: this.searchKeywords,
                    agents: this.agents,
                    companyTypes: this.companyTypes,
                    companies: this.companies,
                    branchCategories: this.branchCategories,
                    policyStatuses: this.policyStatuses,
                    birthday: this.birthday,
                    zip: this.zip,
                    has_terminations: this.terminationValue,

                    startDateFrom: this.startDateFrom,
                    startDateTo: this.startDateTo,
                    endDateFrom: this.endDateFrom,
                    endDateTo: this.endDateTo,
                    submitDateFrom: this.submitDateFrom,
                    submitDateTo: this.submitDateTo,

                    payment_status: this.paymentStatus,

                    teams: selectedTeams,
                    export: true,
                });
            }
            this.isRequesting = false;
        },

        async exportPoliciesTable() {
            this.isRequesting = true;

            const selectedTeams = this.userTeamInput?.length ? this.userTeamInput : this.selectedTeam || [];
            await this.$store.dispatch("searchPolicies", {
                searchKeywords: this.searchKeywords,
                agents: this.agents,
                companies: this.companies,
                branchCategories: this.branchCategories,
                policyStatuses: this.policyStatuses,
                startDateFrom: this.startDateFrom,
                startDateTo: this.startDateTo,
                endDateFrom: this.endDateFrom,
                endDateTo: this.endDateTo,
                submitDateFrom: this.submitDateFrom,
                submitDateTo: this.submitDateTo,
                selectedTeam: selectedTeams,
                export: true
            });

            this.isRequesting = false;
        },

        async exportUsersTable() {
            this.isRequesting = true;

            const selectedTeams = this.userTeamInput?.length ? this.userTeamInput : this.selectedTeam || [];
            await this.$store.dispatch("searchUsers", {
                searchKeywords: this.searchKeywords,
                selectedTeam: selectedTeams,
                status: this.selectedStatus,
                isExport: true
            });

            this.isRequesting = false;
        },

        async exportLeadsTable() {
            this.isRequesting = true;

            const selectedTeams = this.userTeamInput?.length ? this.userTeamInput : this.selectedTeam || [];
            await this.$store.dispatch("searchLeads", {
                search: this.searchKeywords,
                agents: this.agents,
                lead_statuses: this.leadStatuses,
                lead_categories: this.leadCategories,
                lead_referrals: this.leadReferals,
                deadline_from: this.deadlineFrom,
                deadline_to: this.deadlineTo,
                zip_from: this.zipFrom,
                zip_to: this.zipTo,
                teams: selectedTeams,
                export: true,
            });

            this.isRequesting = false;
        }
    },
};
</script>

<style lang="scss" scoped>
.disabled-input2 {
    color: grey !important;
    font-family: var(--muli-text-semi-bold);
    background-color: var(--bg-1);
}

.payment-type::placeholder {
    color: var(--color-9) !important;
}

.custom-option {
    display: flex;
    align-items: center;
    gap: 1em;
    width: 100%;
}

.icon__payment--pending {
    margin-right: 4px !important;
    margin-left: 2px !important;
}

.custom-option-icon {
    transform: scale(0.7);
}

.slide-fade-in-enter-active {
    transition-duration: 0.4s;
    transition-timing-function: ease-in;
}

.slide-fade-in-leave-active {
    transition-duration: 0.4s;
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-fade-in-enter-to,
.slide-fade-in-leave {
    max-height: 100px;
    overflow: hidden;
}

.slide-fade-in-enter,
.slide-fade-in-leave-to {
    overflow: hidden;
    max-height: 0;
}

.form__field {
    margin-bottom: 0 !important;
}

.divider {
    width: 100%;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px
}

.line-divider {
    flex-grow: 1;
    height: 1px;
    background-color: #B9C2CD;
}

.text-divider {
    color: var(--text-5);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 14px;
    cursor: pointer;

    img {
        width: 16px;
        height: 16px;
    }
}

.select-column {
    border: 1px solid transparent;
    background-color: var(--bg-1);
    box-shadow: 0px 5px 30px var(--shadow-4);
    color: var(--color-9) !important;
}

.birthday-zip-cont {
    display: flex;
    justify-content: space-between;
    //width: 100%;
}

.date-label {
    color: var(--text-5);
    font-family: var(--muli-text-semi-bold);
    font-size: 14px;
    font-style: italic;
}

.search-filter {
    position: absolute;
    top: 100%;
    right: 0;
    background: var(--bg-1);
    width: 900px;
    padding: 60px;
    z-index: 2;
    box-shadow: 0px 5px 30px var(--shadow-4);
    border-radius: var(--radius-3);

    .search-export__button {
        box-shadow: none;
        width: 100% !important;
        background-color: #B9C2CD;
        height: 40px;
        display: flex;
        padding: 0 10px;
        font-size: 16px;
        margin: 0 !important;
        cursor: pointer;
        align-items: center;
        justify-content: center;
        gap: 10px;
        font-family: var(--muli-text-semi-bold);
        color: #FFFFFF;
        border-radius: 10px;
        transition: 0.3s ease;

        &:hover {
            background: var(--text-5);
        }

        img {
            width: 27px;
            transition: 0.3s ease;
        }
    }

    &__title {
        color: var(--text-5);
        font-family: var(--muli-text-semi-bold);
        font-size: var(--medium);
        margin-bottom: 50px;
    }

    &__row,
    &__column--inputs {
        display: flex;
    }

    &__row {
        margin-bottom: 40px;
    }

    &__column {
        flex: 1;
        margin-right: 20px;

        &:last-child {
            margin-right: 0;
        }
    }

    &__button {
        margin: 60px auto 0 auto !important;
    }
}

.button--loading {
    width: 200px;
}

.report {
    &__choose-details {
        height: calc(100% - 220px - 40px);
        padding: 45px 15px 0 15px;

        &-datepickers,
        &-seperator {
            display: flex;
        }

        &-datepickers {
            background: var(--bg-3);
            border-radius: var(--radius-1);
            border: 1px solid transparent;

            &--error {
                background-color: var(--highlight-2);
                border-color: var(--border-9);
            }
        }

        &-month {
            flex: 1;
            margin-right: 15px;
        }

        &-year {
            width: 80px;
        }

        &-seperator {

            border-radius: 0;
            align-items: center;
            justify-content: center;
        }

        &-input {
            width: 55px;
            height: 28px;
            background: var(--bg-16);
            border-radius: var(--radius-1);
            text-align: center;
            color: var(--text-2);
        }
    }
}

[data-theme="dark"] .select--default {
    box-shadow: none;
    border: 1px solid #46505B;
}

.lead-double-column {
    display: flex;
    justify-content: space-between;

    input {
        width: 49% !important;
    }
}
</style>
